/* eslint-disable import/prefer-default-export */
import { UpCommingInvoice } from '@/services/stripe/types'

/**
 * Detects if a preview invoice contains prorated charges based on Stripe API line items
 * According to Stripe docs: "The recommended way to get only the prorations being previewed
 * on the invoice is to consider line items where parent.subscription_item_details.proration is true"
 */
export const detectProrationInInvoice = (previewInvoice: UpCommingInvoice | undefined): boolean => {
  if (!previewInvoice?.lines?.data) return false

  return previewInvoice.lines.data.some(lineItem => {
    const { parent } = lineItem
    if (!parent) return false

    if (parent.subscription_item_details?.proration === true) {
      return true
    }

    if (parent.invoice_item_details?.proration === true) {
      return true
    }

    return false
  })
}
